import React, { createContext, useContext, useState, useEffect } from 'react';

const AudienceContext = createContext();

export const useAudience = () => {
  const context = useContext(AudienceContext);
  if (!context) {
    throw new Error('useAudience must be used within AudienceProvider');
  }
  return context;
};

export const AudienceProvider = ({ children }) => {
  const [audienceType, setAudienceType] = useState(null);
  const [showSelector, setShowSelector] = useState(false);

  useEffect(() => {
    const savedAudience = localStorage.getItem('audienceType');
    if (savedAudience) {
      setAudienceType(savedAudience);
    } else {
      setTimeout(() => setShowSelector(true), 800);
    }
  }, []);

  const selectAudience = (type) => {
    setAudienceType(type);
    localStorage.setItem('audienceType', type);
    setShowSelector(false);
  };

  const toggleAudience = () => {
    const newType = audienceType === 'homeowner' ? 'commercial' : 'homeowner';
    selectAudience(newType);
  };

  const clearAudience = () => {
    setAudienceType(null);
    localStorage.removeItem('audienceType');
    setShowSelector(true);
  };

  return (
    <AudienceContext.Provider
      value={{
        audienceType,
        selectAudience,
        toggleAudience,
        clearAudience,
        showSelector,
        setShowSelector,
        isHomeowner: audienceType === 'homeowner',
        isCommercial: audienceType === 'commercial'
      }}
    >
      {children}
    </AudienceContext.Provider>
  );
};
